import { AppLayout } from "@/layouts/AppLayout"
import { RecipeCard } from "@/components/RecipeCard"
import type { Recipe } from "@/types/models"

interface Props {
  recipes: Recipe[]
  adminMode: boolean
}

export default function RecipesIndex({ recipes, adminMode }: Props) {
  return (
    <AppLayout title="Trending Recipes">
      <section className="space-y-8">
        <header className="flex flex-col gap-2">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-slate-400">
            Today's Picks
          </p>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Trending Recipes
          </h1>
          <p className="text-slate-500">
            Ranked by Pinterest popularity, time decay, and fresh off the press.
          </p>
        </header>

        {recipes.length > 0 ? (
          <div className="space-y-6">
            {recipes.map((recipe, index) => (
              <RecipeCard
                key={recipe.id}
                recipe={recipe}
                large={index % 4 === 0}
                adminMode={adminMode}
              />
            ))}
          </div>
        ) : (
          <p className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center text-slate-500">
            No recipes yet. Check back soon!
          </p>
        )}
      </section>
    </AppLayout>
  )
}
